<template>

    <div class="html-container" :style="style" v-html="html"/>

</template>

<script>
export default {
    props: {
        html: {
            type: String,
            value: ''
        }
    },

    data() {
        return {
            style: ''
        }
    },

    created() {
        const sps = this.html.split('<p');
        const last = sps[sps.length - 1];

        if (last.includes('display:none') && last.includes('data-background')) {
            const i = last.indexOf('background-color:') + 'background-color:'.length;

            this.style = 'background-color:' + last.substr(i, 7) + ';';
        }
    }

}
</script>

<style lang="less">
.html-container {
    font-size: 16px;

    /*img {
        display: block;
        margin: 10px auto 0;
        width: auto;
        height: auto;
        max-width: 100%;
    }*/

    img{
        display: inline;
    }

    h1, h2, h3, h4, h5, p {
        margin-top: 15px;
        text-align: justify;
    }

    h1 {
        font-size: 2em;
    }

    h2 {
        font-size: 1.5em;
    }

    h2 {
        font-size: 1.17em;
    }

    h5 {
        font-size: 0.83em;
    }

    p {

    }

    table {
        color: #606266;
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
    }

    video{
        display: block;
        max-width: 100%;
        margin: 10px auto;
        width: auto;
    }

    th, td {
        padding: 10px 10px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        border: 1px solid #ebeef5;

        p{
            text-align: inherit;
        }
    }

    ._article-images-section img{
        margin-top: 10px;
    }
}

</style>
